import React, { useEffect } from "react";
import Sidebar from "../../components/siderbar/Sidebar";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAdminById, selectAdmin } from "../../redux/admin/adminSlice";
import { selectToken } from "../../redux/auth/authSlice";

function DashboadLayout() {
  const dispatch = useDispatch();
  // const admin = useSelector(selectAdmin);
  const token = useSelector(selectToken);
  const navigate = useNavigate();
  // console.log("admin single", admin);

  useEffect(() => {
    if (!token) {
      navigate("/auth/sign-in");
    }
  }, [token]);

  useEffect(() => {
    dispatch(getAdminById());
  }, [dispatch]);

  return (
    <div className="flex overflow-hidden">
      <div className="">
        <Sidebar />
      </div>
      <div className="h-screen w-[88%] overflow-y-auto ">
        <Outlet />
      </div>
    </div>
  );
}

export default DashboadLayout;
